import { Component } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { Crumb } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ListUpdatesViewModel } from '@app/lists/model/list-updates.model';
import { ListUpdatesService } from '../../services/list-updates.service';
import { FEATURES } from '@shared/constants/splitio-features';
import { ProductConversionContainer } from '../../../shared/models/product-conversion.model';
import { QuantityUpdate } from '../../../shared/models/quantity-update';
import { ProductClickData } from '../../../shared/models/usf-product-card.model';
import { PATHS } from '../../../shared/constants/paths';
import { ProductCompareEnum } from '../../../shared/constants/product-compare.enum';
import { NavigationHelperService } from '../../../shared/helpers/navigation.helpers.service';
import { OrderItemService } from '../../../shared/services/order-item.service';
import { ProductAnalyticsService } from '@usf/ngrx-product';
@Component({
  selector: 'app-list-updates',
  templateUrl: './list-updates.page.html',
  styleUrls: ['./list-updates.page.scss'],
})
export class ListUpdatesPage implements ViewWillEnter {
  breadcrumbs: Crumb[];
  listUpdatesViewModel$: Observable<ListUpdatesViewModel>;
  listUpdatesFlag$: Observable<boolean>;
  constructor(
    readonly platformService: PlatformService,
    private panAppState: PanAppState,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    readonly listUpdatesService: ListUpdatesService,
    private navigationHelperService: NavigationHelperService,
    private orderItemService: OrderItemService,
    private analyticsService: ProductAnalyticsService,
  ) {}

  ionViewWillEnter() {
    this.listUpdatesFlag$ = this.panAppState.feature$([
      FEATURES.split_global_forced_update_notification.name,
    ]);
    this.listUpdatesViewModel$ =
      this.listUpdatesService.getListUpdatesWithDetails$(
        this.route?.snapshot?.data?.productNumbers,
      );
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.listUpdates),
    );
    this.initializeBreadcrumbs();
  }

  openListUpdatesEllipsisMenu = (
    productConversionContainers: ProductConversionContainer[],
  ) => {
    this.listUpdatesService.openEllipsis(productConversionContainers);
  };

  initializeBreadcrumbs() {
    var homeCrumbUrl = this.platformService.isTouch.value
      ? '/touch/home'
      : '/desktop/home';

    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: homeCrumbUrl,
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.myLists',
        url: '/lists',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.listUpdates',
        url: '',
        active: true,
      },
    ];
  }

  handleDownload = (
    productConversionContainers: ProductConversionContainer[],
  ) => {
    this.listUpdatesService.downloadUpdates(productConversionContainers);
  };

  handlePrint = (productConversionContainers: ProductConversionContainer[]) => {
    this.listUpdatesService.printUpdates(productConversionContainers);
  };

  handleCompareClick(productConversionContainer: ProductConversionContainer) {
    const originalProductNumber =
      productConversionContainer.originalProduct.productNumber;
    const replacementProductNumber =
      productConversionContainer.replacementProduct.productNumber;
    this.navigationHelperService.routeTo(PATHS.SEARCH_COMPARE, {
      selectedProducts: `${originalProductNumber},${replacementProductNumber}`,
      originalItem: originalProductNumber,
      mode: ProductCompareEnum.replacementListsCompare,
    });
  }

  changeQuantityHandler(event: {
    quantityUpdate: QuantityUpdate;
    productConversionContainer: ProductConversionContainer;
  }) {
    this.orderItemService.changeQuantity(
      event.quantityUpdate.productNumber,
      event.quantityUpdate.quantity,
      event.quantityUpdate.isEaches,
    );
  }

  trackProductImageClick(productClickData: ProductClickData) {
    this.analyticsService.trackProductImageClick(
      productClickData?.product?.summary?.divisionNumber,
      productClickData?.productNumber,
      productClickData?.product?.trackingAttributes,
      productClickData?.product?.resultRank,
    );
  }

  handleProductImageClick(event: ProductClickData) {
    this.trackProductImageClick(event);
    this.navigationHelperService.routeToProductDetailsQueryParams(
      event.productNumber,
    );
  }
}
